import { useEffect, useState } from 'react';
import { generateFormField } from '../../../utils/form/generate-form-fields/generate-form-fields';
import { FormSourceEnum } from '../../form-hook/form-field/hooks/use-set-options/use-set-options.props';
import { errorMessages } from '../../../utils/error-messages';
import { ConfigurationFromPdfFieldNames } from '../configuration-from-pdf.types';
import cloneDeep from 'lodash/cloneDeep';
import { UseFormReturn } from 'react-hook-form';

const useDriverFields = (isPoolcar: boolean, reactHookFormData: UseFormReturn) => {
  const { setValue, clearErrors, getValues } = reactHookFormData;

  const [showMaxConfigurationsHint, setShowMaxConfigurationsHint] = useState(false);
  const [driverFields, setDriverFields] = useState([
    generateFormField.lookup({
      label: 'Fahrer',
      name: ConfigurationFromPdfFieldNames.Driver,
      disabled: false,
      source: FormSourceEnum.GetCompanyDrivers,
      validation: {
        required: errorMessages.requiredOptionSet
      }
    })
  ]);

  const driverValue = getValues(ConfigurationFromPdfFieldNames.Driver);

  useEffect(() => {
    setShowMaxConfigurationsHint(false);
  }, [driverValue]);

  useEffect(() => {
    const newDriverFields = cloneDeep(driverFields);
    newDriverFields[0].disabled = isPoolcar;
    newDriverFields[0].validation.required = isPoolcar ? false : errorMessages.requiredOptionSet;
    setDriverFields(newDriverFields);
  }, [isPoolcar]);

  useEffect(() => {
    if (driverFields[0].disabled) {
      setValue(ConfigurationFromPdfFieldNames.Driver, '');
      clearErrors(ConfigurationFromPdfFieldNames.Driver);
    }
  }, [driverFields[0].disabled]);

  return { driverFields, showMaxConfigurationsHint, setShowMaxConfigurationsHint };
};

export default useDriverFields;
